<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-12 15:54:38
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-12 19:05:25
 * @name: 分页器
 * @Description: 分页器
 * @FilePath: \backstage\src\components\public\Pagination.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <el-pagination
    small="small"
    background
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    :page-sizes="pageSizes"
    :page-size="pageSize"
    :current-page="page"
    @current-change="currentChange"
    @size-change="sizeChange"
  ></el-pagination>
</template>
<script>
export default {
  name: "Pagination",
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [5, 10, 20, 50];
      },
    },
    page: {
      type: Number,
      required: true,
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    currentChange(e) {
      this.$emit("update:page", e);
    },
    sizeChange(e) {
      this.$emit("update:page-size", e);
    },
  },
};
</script>